module.exports = __webpack_public_path__ + "static/media/fripulia-r-en.1489c5a8.png";